import PropTypes from 'prop-types';
import React from 'react';
import './stamp-denominations.css';

const StampDenominations = (stampDenominations) => (
	<table className='custom-table-pdfDetails'>
		<tbody>
			<tr>
				<th>Denominations</th>
				<th>Quantity</th>
			</tr>
			{stampDenominations?.stampDenominations?.map((denomination, i) => (
				<tr key={i + 'denomination' + denomination.id}>
					<td>{Number(denomination?.stampDenomination)}</td>
					<td>{denomination?.stampQuantity?.toString().padStart(2, '0')}</td>
				</tr>
			))}
		</tbody>
	</table>
);

export default StampDenominations;

StampDenominations.propTypes = PropTypes.any;
